import React, {useEffect, useState} from 'react';
import {
    Paper, Table,
    TableBody, TableCell, TableContainer, TablePagination, TableRow, LinearProgress

} from '@material-ui/core/';

import {coreStyle, EnhancedTableHead} from "../../styles/config";
import GrowerParent from "./add";
import DeleteButton from "../../utils/delete";
import {parseQueryParams} from "../../utils/helpers";
import Resource from "../../crud/resource";
import Search from "../../widgets/Search";
import {useSelector} from "react-redux";
import Translate from "../../utils/utils";

const headCells = [
    {id: 'rfh_number', label: <Translate id={"TABLE.RFH_NUMBER"}/>},
    {id: 'name', label: <Translate id={"TABLE.NAME"}/>},
    {id: 'phone', label: <Translate id={"TABLE.PHONE"}/>},
    {id: 'contact', label: <Translate id={"TABLE.CONTACT"}/>},
    {id: 'date', label: <Translate id={"TABLE.DATE"}/>},
    {id: 'actions', label: <Translate id={"TABLE.ACTIONS"}/>},
];

export default function GrowerParentList(props) {
    const {location: {search}, history} = props;
    const queryParams = parseQueryParams(search);
    const [page, setPage] = React.useState(queryParams.page);
    const perPage = queryParams.perPage;;
    const [growerParents, setGrowerParents] = useState([]);
    const initialValues = {name: "", email: "", phone: "", rfh_number: '', contact: ''};
    const [growerParent, setGrowerParent] = useState(initialValues);
    const [name, setName] = useState(queryParams.name);
    const [isLoading, setIsLoading] = useState(false);
    const resource = new Resource('growerParent');
    const [pagination, setPagination] = useState({
        total: 0,
        current_page: 1,
        per_page: queryParams.perPage,
    });
    const user = useSelector(store => store.auth.user);

    const removeItemInListing = (id) => {
        const remaining = growerParents.filter(item => item.id !== id);
        const total = remaining.length;
        setPagination(Object.assign(pagination, {total: pagination.total - 1, 'to': total}));
        setGrowerParents(remaining);
    };

    useEffect(() => {
        const list = () => {
            const resource = new Resource('growerParent');
            setIsLoading(true);
            resource.index({
                perPage,
                page,
                name
            })
                .then(response => {
                    const {data: {data = {data: []}}} = response;
                    const paginationData = data;
                    setGrowerParents(paginationData.data);
                    setPagination(paginationData);
                    setIsLoading(false);
                }).catch(err => {
                setIsLoading(false);
            });
        };
        list();
    }, [page, perPage]);


    const handleChangePage = (e, page) => {
        setPage(++page);
        history.push(`?page=${page}&perPage=${perPage}&name=${name}`);
    };

    const handlePerPageChange = (perPage) => {
        history.push(`?page=${page}&perPage=${perPage}&name=${name}`);
    };

    const handleCreate = (growerParent) => {
        const growersList = [growerParent, ...growerParents];
        setGrowerParents(growersList);
    };

    const handleUpdate = (growerParent) => {
        const growerParentList = growerParents.map(item => {
            if (item.id === growerParent.id) {
                return growerParent;
            }
            return item;
        });
        setGrowerParents(growerParentList);
    };

    const onType = (e) => {
        const {target: {value}} = e;
        setName(value);
    };

    const onClearSearch = () => {
        history.push(`?page=1&perPage=${perPage}`);
    };

    const onSearch = () => {
        history.push(`?page=1&perPage=${perPage}&name=${name}`);
    };

    return (
        <div className={coreStyle.root}>
            <div className="add-user__button">
                <GrowerParent handleCreate={handleCreate} resource={resource} initialValues={growerParent}
                              key={growerParent.id}
                              handleUpdate={handleUpdate} onCloseModal={() => setGrowerParent(initialValues)}/>
            </div>

            <Search onType={onType} onSubmit={onSearch} module={"Grower Parent"} onClear={onClearSearch}
                    value={queryParams.name}
                    disabled={isLoading}/>

            {isLoading && <LinearProgress color="secondary"/>}
            <Paper className={coreStyle.paper}>
                <TableContainer>
                    <Table
                        className={coreStyle.table}
                        aria-labelledby="tableTitle"
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            rowCount={growerParents.length}
                            headCells={headCells}
                            isLoading={isLoading}
                        />
                        <TableBody>
                            {growerParents.map(growerParent => {
                                return (
                                    <TableRow
                                        hover
                                        tabIndex={-1}
                                        key={growerParent.id}
                                    >
                                        <TableCell>{growerParent.rfh_number}</TableCell>
                                        <TableCell component="th" scope="row">
                                            {growerParent.name}
                                        </TableCell>
                                        <TableCell>{growerParent.phone}</TableCell>
                                        <TableCell>{growerParent.contact}</TableCell>
                                        <TableCell>{growerParent.created_at}</TableCell>
                                        <TableCell>
                                            <button className='button-edit-delete'
                                                    onClick={() => {
                                                        setGrowerParent(growerParent)
                                                    }}>
                                                <Translate id={"TABLE.ACTIONS.EDIT"}/>
                                            </button>

                                            {user.role.name !== 'INSPECTOR' &&
                                            <>
                                                <em className='actions-separator'>|</em>
                                                <DeleteButton
                                                    module={`growerParent`}
                                                    itemId={growerParent.id}
                                                    itemName={growerParent.name}
                                                    removeItemInListing={removeItemInListing}
                                                />
                                            </>
                                            }

                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[15, 50, 100]} labelRowsPerPage={<Translate id="TABLE.ROWS_PER_PAGE"/>}
                    component="div"
                    count={pagination.total}
                    rowsPerPage={pagination.per_page}
                    page={pagination.current_page - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={(e) => handlePerPageChange(e.target.value)}
                />
            </Paper>
        </div>
    );
}
